export type StockExchangeOption = {
  exchange: string;
  name: string;
  country: string;
};

export const STOCK_EXCHANGES: StockExchangeOption[] = [
  // Major exchanges
  { exchange: 'NYSE', name: 'New York', country: 'United States' },
  { exchange: 'NASDAQ', name: 'New York', country: 'United States' },
  { exchange: 'LSE', name: 'London', country: 'United Kingdom' },
  { exchange: 'JPX', name: 'Japan', country: 'Japan' },
  { exchange: 'HKSE', name: 'Hong Kong', country: 'Hong Kong' },
  { exchange: 'EURONEXT', name: 'Europe', country: 'Europe' },
  { exchange: 'TSX', name: 'Toronto', country: 'Canada' },
  { exchange: 'SIX', name: 'Switzerland', country: 'Switzerland' },
  { exchange: 'NSE', name: 'India', country: 'India' },
  // Other exchanges in alphabetical order
  { exchange: 'AMEX', name: 'USA', country: 'United States' },
  { exchange: 'AMS', name: 'Amsterdam', country: 'Netherlands' },
  { exchange: 'AQS', name: 'UK', country: 'United Kingdom' },
  { exchange: 'ATH', name: 'Athens', country: 'Greece' },
  { exchange: 'BER', name: 'Berlin', country: 'Germany' },
  { exchange: 'BME', name: 'Spain', country: 'Spain' },
  { exchange: 'BRU', name: 'Brussels', country: 'Belgium' },
  { exchange: 'BSE', name: 'Bombay', country: 'India' },
  { exchange: 'BUD', name: 'Budapest', country: 'Hungary' },
  { exchange: 'BUE', name: 'Buenos Aires', country: 'Argentina' },
  { exchange: 'BVC', name: 'Colombia', country: 'Colombia' },
  { exchange: 'CBOE', name: 'Chicago', country: 'United States' },
  { exchange: 'CNQ', name: 'Canada', country: 'Canada' },
  { exchange: 'CPH', name: 'Copenhagen', country: 'Denmark' },
  { exchange: 'DFM', name: 'Dubai', country: 'United Arab Emirates' },
  { exchange: 'DOH', name: 'Doha', country: 'Qatar' },
  { exchange: 'DUB', name: 'Euronext Dublin', country: 'Ireland' },
  { exchange: 'DUS', name: 'Düsseldorf', country: 'Germany' },
  { exchange: 'DXE', name: 'Deutsche Börse', country: 'Germany' },
  { exchange: 'EGX', name: 'Egypt', country: 'Egypt' },
  { exchange: 'FSX', name: 'Frankfurt', country: 'Germany' },
  { exchange: 'HAM', name: 'Hamburg', country: 'Germany' },
  { exchange: 'HEL', name: 'Helsinki', country: 'Finland' },
  { exchange: 'HOSE', name: 'Ho Chi Minh City', country: 'Vietnam' },
  { exchange: 'ICE', name: 'USA', country: 'United States' },
  { exchange: 'IOB', name: 'London', country: 'United Kingdom' },
  { exchange: 'IST', name: 'Istanbul', country: 'Turkey' },
  { exchange: 'JKT', name: 'Indonesia', country: 'Indonesia' },
  { exchange: 'JNB', name: 'Johannesburg', country: 'South Africa' },
  { exchange: 'KLS', name: 'Malaysia', country: 'Malaysia' },
  { exchange: 'KOE', name: 'South Korea', country: 'South Korea' },
  { exchange: 'KSC', name: 'Kuwait', country: 'Kuwait' },
  { exchange: 'KUW', name: 'Kuwait', country: 'Kuwait' },
  { exchange: 'LIS', name: 'Euronext Lisbon', country: 'Portugal' },
  { exchange: 'MCX', name: 'India', country: 'India' },
  { exchange: 'MEX', name: 'Mexico', country: 'Mexico' },
  { exchange: 'MIL', name: 'Milan', country: 'Italy' },
  { exchange: 'MUN', name: 'Munich', country: 'Germany' },
  { exchange: 'NEO', name: 'Canada', country: 'Canada' },
  { exchange: 'NZE', name: 'New Zealand', country: 'New Zealand' },
  { exchange: 'OEM', name: 'Osaka', country: 'Japan' },
  { exchange: 'OQB', name: 'USA', country: 'United States' },
  { exchange: 'OSL', name: 'Oslo', country: 'Norway' },
  { exchange: 'OTC', name: 'USA', country: 'United States' },
  { exchange: 'PAR', name: 'Paris', country: 'France' },
  { exchange: 'PNK', name: 'USA', country: 'United States' },
  { exchange: 'PRA', name: 'Prague', country: 'Czech Republic' },
  { exchange: 'RIS', name: 'Riga', country: 'Latvia' },
  { exchange: 'SAO', name: 'São Paulo', country: 'Brazil' },
  { exchange: 'SAU', name: 'Saudi Arabia', country: 'Saudi Arabia' },
  { exchange: 'SES', name: 'Singapore', country: 'Singapore' },
  { exchange: 'SET', name: 'Thailand', country: 'Thailand' },
  { exchange: 'SGO', name: 'Santiago', country: 'Chile' },
  { exchange: 'SHH', name: 'Shanghai', country: 'China' },
  { exchange: 'SHZ', name: 'Shenzhen', country: 'China' },
  { exchange: 'STO', name: 'Sweden', country: 'Sweden' },
  { exchange: 'STU', name: 'Stuttgart', country: 'Germany' },
  { exchange: 'TAI', name: 'Taiwan', country: 'Taiwan' },
  { exchange: 'TAL', name: 'Estonia', country: 'Estonia' },
  { exchange: 'TLV', name: 'Tel Aviv', country: 'Israel' },
  { exchange: 'TSXV', name: 'Canada', country: 'Canada' },
  { exchange: 'TWO', name: 'Taipei', country: 'Taiwan' },
  { exchange: 'VIE', name: 'Vienna', country: 'Austria' },
  { exchange: 'WSE', name: 'Warsaw', country: 'Poland' },
  { exchange: 'XETRA', name: 'Germany', country: 'Germany' },
];

export const stockExchangeLabel = (exchangeSymbol: string): string => {
  const exchange = STOCK_EXCHANGES.find(option => option.exchange === exchangeSymbol);
  return exchange ? `${exchange.exchange} · ${exchange.country}` : exchangeSymbol;
};
